import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "profile-tabs custom-checkboxes-group" }
const _hoisted_2 = { class: "profile-tabs-checkboxes custom-checkboxes" }
const _hoisted_3 = ["id", "name", "checked", "disabled", "onInput"]

import { toRefs, withDefaults } from 'vue'

  interface Props {
    tabs: string[]
    selectedTab: string
    edition: boolean
    disabled?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: null,
    selectedTab: null,
    edition: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { tabs: string[], selectedTab: string, edition: boolean, disabled: boolean }

  

  const { tabs, selectedTab, disabled } = toRefs(props)

  function getPath(tab: string) {
    switch (tab) {
      case 'PICTURE':
        return '/profile/edit/picture'
      case 'PREFERENCES':
      case 'SPORTS':
        return `/profile${
          props.edition ? '/edit' : ''
        }/${tab.toLocaleLowerCase()}`
      default:
      case 'PROFILE':
        return `/profile${props.edition ? '/edit' : ''}`
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "profile-tab custom-checkbox",
          key: tab
        }, [
          _createElementVNode("label", null, [
            _createElementVNode("input", {
              type: "radio",
              id: tab,
              name: tab,
              checked: _unref(selectedTab) === tab,
              disabled: _unref(disabled),
              onInput: ($event: any) => (_ctx.$router.push(getPath(tab)))
            }, null, 40, _hoisted_3),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`user.PROFILE.TABS.${tab}`)), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})